export default __webpack_public_path__ + "static/media/news6.094860f3.png";